module.exports = __webpack_public_path__ + "img/events_2.add47ea6.jpg";